module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAF8AAAAQCAYAAABwQqNMAAAACXBIWXMAAAsSAAALEgHS3X78AAAAj0lEQVRYhe2TzQ2AMAhGqZM4gkkZwFEcpaM4igOwUz14M/60QBsTv3eHhPdCyDkT0MHMs4hs2vkB3k2MzLxoF0C+ARFZ6fgAVQDIN2IJAPkOaANAvhOaAJDvSG0AyHemJgDkN6A0AOQ3oiQA5DfkLQDkN+YpAOR34C4A5HfiKgDkd+QcIMQY009u/xITEaUdQPc+Ae4cTNYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/img/dnx-87.png
// module id = GdhU
// module chunks = 1